import { Text, Flex, type FlexProps } from '@mantine/core';
import classes from './FormPhoneInput.module.scss';
import {
  PhoneInput,
  type PhoneInputProps,
} from '@shared/ui/PhoneInput/PhoneInput';

interface FormPhoneInputProps extends PhoneInputProps {
  title: string;
  description: string;
  containerProps?: FlexProps;
}

export const FormPhoneInput = ({
  title,
  description,
  containerProps,
  ...props
}: FormPhoneInputProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>
      <PhoneInput className={classes.rightColumn} variant='filled' {...props} />
    </Flex>
  );
};
